export var STIMULI_ACTION;
(function (STIMULI_ACTION) {
  STIMULI_ACTION["SET_STIMULI"] = "SET_STIMULI";
  STIMULI_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
})(STIMULI_ACTION || (STIMULI_ACTION = {}));
export var GENERAL_ACTION;
(function (GENERAL_ACTION) {
  GENERAL_ACTION["SET_ERROR"] = "SET_ERROR";
  GENERAL_ACTION["SET_SHOW_DISCARD_KEYWORD_GENERATION_MODAL"] = "SET_SHOW_DISCARD_KEYWORD_GENERATION_MODAL";
  GENERAL_ACTION["SET_SHOW_DISCARD_KEYWORDS_MODAL"] = "SET_SHOW_DISCARD_KEYWORDS_MODAL";
  GENERAL_ACTION["SET_SHOW_UPDATE_AUTOTAGGING_MODAL"] = "SET_SHOW_UPDATE_AUTOTAGGING_MODAL";
  GENERAL_ACTION["SET_UPDATE_AUTOTAGGING_MODAL_SEEN_COUNT"] = "SET_UPDATE_AUTOTAGGING_MODAL_SEEN_COUNT";
  GENERAL_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
})(GENERAL_ACTION || (GENERAL_ACTION = {}));
export var FILTERS_ACTION;
(function (FILTERS_ACTION) {
  FILTERS_ACTION["SET_SEARCH"] = "SET_SEARCH";
  FILTERS_ACTION["SET_SORT_BY"] = "SET_SORT_BY";
  FILTERS_ACTION["SET_FILTER_BY_TAGGED_STATUS"] = "SET_FILTER_BY_TAGGED_STATUS";
  FILTERS_ACTION["SET_DISABLED"] = "SET_DISABLED";
  FILTERS_ACTION["SET_SELECTED_THEMES"] = "SET_SELECTED_THEMES";
  FILTERS_ACTION["SET_SELECTED_STIMULI"] = "SET_SELECTED_STIMULI";
  FILTERS_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
  FILTERS_ACTION["SET_SELECTED_SENTIMENT"] = "SET_SELECTED_SENTIMENT";
})(FILTERS_ACTION || (FILTERS_ACTION = {}));
export var THEMES_ACTION;
(function (THEMES_ACTION) {
  THEMES_ACTION["SET_INITIAL_THEMES"] = "SET_INITIAL_THEMES";
  THEMES_ACTION["SET_THEMES"] = "SET_THEMES";
  THEMES_ACTION["SET_KEYWORDS"] = "SET_KEYWORDS";
  THEMES_ACTION["SET_KEYWORDS_LOADING"] = "SET_KEYWORDS_LOADING";
  THEMES_ACTION["SET_KEYWORDS_ERROR"] = "SET_KEYWORDS_ERROR";
  THEMES_ACTION["SET_THEMES_LOADING"] = "SET_THEMES_LOADING";
  THEMES_ACTION["SET_THEMES_ERROR"] = "SET_THEMES_ERROR";
  THEMES_ACTION["ADD_THEME"] = "ADD_THEME";
  THEMES_ACTION["SET_THEMES_ADDED"] = "SET_THEMES_ADDED";
  THEMES_ACTION["SET_THEMES_DELETED"] = "SET_THEMES_DELETED";
  THEMES_ACTION["SET_THEMES_CHANGED"] = "SET_THEMES_CHANGED";
  THEMES_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
})(THEMES_ACTION || (THEMES_ACTION = {}));
export var THEMES_REUSE_ACTION;
(function (THEMES_REUSE_ACTION) {
  THEMES_REUSE_ACTION["SET_PREVIOUSLY_USED_THEMES"] = "SET_PREVIOUSLY_USED_THEMES";
  THEMES_REUSE_ACTION["SET_SUGGESTED_THEMES"] = "SET_SUGGESTED_THEMES";
  THEMES_REUSE_ACTION["SET_SUGGESTED_THEMES_FOR_RESPONSE"] = "SET_SUGGESTED_THEMES_FOR_RESPONSE";
  THEMES_REUSE_ACTION["SET_USE_CASES"] = "SET_USE_CASES";
  THEMES_REUSE_ACTION["SET_SELECTED_USE_CASE"] = "SET_SELECTED_USE_CASE";
  THEMES_REUSE_ACTION["SET_SELECTED_REUSED_THEMES"] = "SET_SELECTED_REUSED_THEMES";
  THEMES_REUSE_ACTION["ADD_REUSED_THEME"] = "ADD_REUSED_THEME";
  THEMES_REUSE_ACTION["REMOVE_REUSED_THEME"] = "REMOVE_REUSED_THEME";
  THEMES_REUSE_ACTION["ADD_PREVIOUSLY_USED_THEME"] = "ADD_PREVIOUSLY_USED_THEME";
  THEMES_REUSE_ACTION["REMOVE_PREVIOUSLY_USED_THEME"] = "REMOVE_PREVIOUSLY_USED_THEME";
  THEMES_REUSE_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
})(THEMES_REUSE_ACTION || (THEMES_REUSE_ACTION = {}));
export var RESPONSES_ACTION;
(function (RESPONSES_ACTION) {
  RESPONSES_ACTION["SET_RESPONSES"] = "SET_RESPONSES";
  RESPONSES_ACTION["SET_RESPONSES_ERROR"] = "SET_RESPONSES_ERROR";
  RESPONSES_ACTION["SET_RESPONSES_LOADING"] = "SET_RESPONSES_LOADING";
  RESPONSES_ACTION["SET_RESPONSES_PAGE_SIZE"] = "SET_RESPONSES_PAGE_SIZE";
  RESPONSES_ACTION["SET_RESPONSES_PAGE"] = "SET_RESPONSES_PAGE";
  RESPONSES_ACTION["SET_RESPONSES_COUNT"] = "SET_RESPONSES_COUNT";
  RESPONSES_ACTION["SET_RESPONSES_TOTAL"] = "SET_RESPONSES_TOTAL";
  RESPONSES_ACTION["SET_RESPONSES_CHANGED"] = "SET_RESPONSES_CHANGED";
  RESPONSES_ACTION["SET_SHOW_SA"] = "SET_SHOW_SA";
  RESPONSES_ACTION["SET_SA_STATS"] = "SET_SA_STATS";
  RESPONSES_ACTION["SET_SIGNIFICANT_CHANGES_TO_RESPONSES"] = "SET_SIGNIFICANT_CHANGES_TO_RESPONSES";
  RESPONSES_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
})(RESPONSES_ACTION || (RESPONSES_ACTION = {}));
export var TRAINING_ACTION;
(function (TRAINING_ACTION) {
  TRAINING_ACTION["SET_TRAINING_STATUS"] = "SET_TRAINING_STATUS";
  TRAINING_ACTION["SET_UNSAVED_KEYWORDS"] = "SET_UNSAVED_KEYWORDS";
  TRAINING_ACTION["SET_GENERATED_KEYWORDS"] = "SET_GENERATED_KEYWORDS";
  TRAINING_ACTION["SET_SUMMARY_COUNTS"] = "SET_SUMMARY_COUNTS";
  TRAINING_ACTION["SET_TRAINING_ERROR"] = "SET_TRAINING_ERROR";
  TRAINING_ACTION["SET_TRAINING_COMPLETE"] = "SET_TRAINING_COMPLETE";
  TRAINING_ACTION["SET_SHOW_TRAINING_SCREEN"] = "SET_SHOW_TRAINING_SCREEN";
  TRAINING_ACTION["SET_SHOULD_REFETCH_ON_OPEN"] = "SET_SHOULD_REFETCH_ON_OPEN";
  TRAINING_ACTION["SET_SHOW_TRAINING_ERROR_TOAST"] = "SET_SHOW_TRAINING_ERROR_TOAST";
  TRAINING_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
})(TRAINING_ACTION || (TRAINING_ACTION = {}));
export var RETRAINING_ACTION;
(function (RETRAINING_ACTION) {
  RETRAINING_ACTION["SET_TRAINING_STATUS"] = "SET_TRAINING_STATUS";
  RETRAINING_ACTION["SET_NOT_ENOUGH_THEMES_CREATED"] = "SET_NOT_ENOUGH_THEMES_CREATED";
  RETRAINING_ACTION["SET_NOT_ENOUGH_RESPONSES_TAGGED"] = "SET_NOT_ENOUGH_RESPONSES_TAGGED";
  RETRAINING_ACTION["SET_APPLY_THEME_TO_MORE_RESPONSES"] = "SET_APPLY_THEME_TO_MORE_RESPONSES";
  RETRAINING_ACTION["SET_NOT_ENOUGH_THEMES_CREATED_STEP"] = "SET_NOT_ENOUGH_THEMES_CREATED_STEP";
  RETRAINING_ACTION["SET_NOT_ENOUGH_RESPONSES_TAGGED_STEP"] = "SET_NOT_ENOUGH_RESPONSES_TAGGED_STEP";
  RETRAINING_ACTION["SET_APPLY_THEME_TO_MORE_RESPONSES_STEP"] = "SET_APPLY_THEME_TO_MORE_RESPONSES_STEP";
  RETRAINING_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
})(RETRAINING_ACTION || (RETRAINING_ACTION = {}));
export var FEEDBACK_ACTION;
(function (FEEDBACK_ACTION) {
  FEEDBACK_ACTION["SET_AUTOTAGGING_PREDICTION_ID"] = "SET_AUTOTAGGING_PREDICTION_ID";
  FEEDBACK_ACTION["SET_KEYWORD_PREDICTION_ID"] = "SET_KEYWORD_PREDICTION_ID";
  FEEDBACK_ACTION["SET_JOB_ID"] = "SET_JOB_ID";
  FEEDBACK_ACTION["SET_MULTIPLE"] = "SET_MULTIPLE";
})(FEEDBACK_ACTION || (FEEDBACK_ACTION = {}));